import { render, staticRenderFns } from "./WithoutResults.vue?vue&type=template&id=def9216a&"
import script from "./WithoutResults.vue?vue&type=script&lang=js&"
export * from "./WithoutResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports